import { fetchAuthSession } from "aws-amplify/auth";
import { API_URL } from "./config";

async function getToken() {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() || "";
}

async function request(method, path, body) {
  const token = await getToken();
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message || `HTTP ${res.status}`);
  }
  return res.json();
}

// ── Donations ─────────────────────────────────────────────────────────
export const donationsApi = {
  list: () => request("GET", "/donations"),
  get: (id) => request("GET", `/donations/${id}`),
  create: (data) => request("POST", "/donations", data),
  updateStatus: (id, status) => request("PUT", `/donations/${id}`, { status }),
};

// ── Expenses ──────────────────────────────────────────────────────────
export const expensesApi = {
  list: () => request("GET", "/expenses"),
  create: (data) => request("POST", "/expenses", data),
  update: (id, data) => request("PUT", `/expenses/${id}`, data),
  delete: (id) => request("DELETE", `/expenses/${id}`),
};

// ── Events ────────────────────────────────────────────────────────────
export const eventsApi = {
  list: () => request("GET", "/events"),
  create: (data) => request("POST", "/events", data),
  update: (id, data) => request("PUT", `/events/${id}`, data),
};

// ── Volunteers ────────────────────────────────────────────────────────
export const volunteersApi = {
  list: () => request("GET", "/volunteers"),
  create: (data) => request("POST", "/volunteers", data),
  update: (id, data) => request("PUT", `/volunteers/${id}`, data),
};

// ── Members ───────────────────────────────────────────────────────────
export const membersApi = {
  list: () => request("GET", "/members"),
  create: (data) => request("POST", "/members", data),
  update: (id, data) => request("PUT", `/members/${id}`, data),
  resendInvite: (email) => request("POST", "/members", { action: "resend-invite", email }),
};

// ── Sponsors ──────────────────────────────────────────────────────────
export const sponsorsApi = {
  list: () => request("GET", "/sponsors"),
  create: (data) => request("POST", "/sponsors", data),
  update: (id, data) => request("PUT", `/sponsors/${id}`, data),
};

// ── WhatsApp ──────────────────────────────────────────────────────────
export const whatsappApi = {
  send: (payload) => request("POST", "/whatsapp/send", payload),
};

// ── Leaderboard (public, no auth) ────────────────────────────────────
async function publicRequest(path) {
  const res = await fetch(`${API_URL}${path}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message || `HTTP ${res.status}`);
  }
  return res.json();
}

export const leaderboardApi = {
  list: () => publicRequest("/leaderboard"),
};
